import React, { useState, useEffect, useContext } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Typography,
  Space,
  Segmented,
  Input,
} from "antd";
import { useNavigate } from "react-router-dom";
import btnStyles from "../../../styles/Custom/Button.module.css";
import textStyles from "../../../styles/Custom/Typography.module.css";
import BedForm from "./BedForm";
import Buildings from "./FloorPlan/Buildings";
import RoomTypeForm from "./RoomTypeForm";
import {
  getAllBedsListApi,
  getRoomTypeApi,
} from "../../../services/beds.services";
import { PlusOutlined, SettingOutlined } from "@ant-design/icons";
import BedTable from "./BedTable";
import { UserContext } from "../../../context/UserContext";
import { getCookie } from "../../../helpers/localStorage";
import { Role } from "../../../constants/defaultKeys";
import { UiDataTable } from "../../ui";
import useQuery from "../../../hooks/useQuery";
import {
  parseSearchParam,
  updateUrlSearchParams,
} from "../../../helpers/urlFilters";

const BedManagement = ({ id }) => {
  const { userDetails } = useContext(UserContext);
  const navigate = useNavigate();
  const params = useQuery();
  const activeSegment =
    params?.view === "beds_table" ? "Beds Table" : "Floor Plan";
  const searchQuery = parseSearchParam(params);
  const [isVisible, setIsVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const items = ["Floor Plan", "Beds Table"];
  const [refresh, setRefresh] = useState(false);
  const [roomTypes, setRoomTypes] = useState([]);
  const [bedList, setBedList] = useState([]);
  const [bedRefresh, setBedRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const refreshPage = () => {
    setRefresh((prev) => !prev);
  };
  const refreshBedPage = () => {
    setBedRefresh((prev) => !prev);
  };
  useEffect(() => {
    getRoomTypeApi()
      .then((res) => setRoomTypes(res?.data))
      .catch((err) => {
        console.log(err);
      });
  }, [refresh]);

  useEffect(() => {
    if (id) {
      getAllBedsListApi(id)
        .then((res) => {
          setBedList(res?.data);
          setFilteredData(res?.data); // Initialize filteredData
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [id, bedRefresh, activeSegment]);

  useEffect(() => {
    if (!searchQuery) {
      setFilteredData(bedList);
      return;
    }
    const query = searchQuery.toLowerCase();
    setFilteredData(
      bedList?.filter((bed) => bed?.bed_no?.toLowerCase()?.includes(query)) ?? []
    );
  }, [bedList, searchQuery]);

  const onChange = (value) => {
    updateUrlSearchParams(navigate, {
      view: value === "Beds Table" ? "beds_table" : "floor_plan",
      search: null,
    });
  };
  const defaultRole = userDetails?.currRole || getCookie(Role);
  const onBedSearch = (e) => {
    const query = e?.target?.value?.toLowerCase() || "";
    updateUrlSearchParams(navigate, { search: query || null });

    if (!query) {
      setFilteredData(bedList);
    } else {
      const filteredBeds = bedList?.filter((bed) =>
        bed?.bed_no?.toLowerCase()?.includes(query)
      );
      setFilteredData(filteredBeds);
    }
  };
  return (
    <>
      <Card
        title={
          <Space>
            <Typography>Bed Management</Typography>{" "}
            <Segmented
              options={items}
              value={activeSegment}
              onChange={onChange}
            />
          </Space>
        }
        extra={
          defaultRole === "Facility_Admin" ? null : (
            <span
              onClick={() => setOpen(true)}
              style={{ cursor: "pointer", fontSize: "11px", fontWeight: 600 }}
            >
              <SettingOutlined /> Manage Room types
            </span>
          )
        }
        style={{
          borderRadius: "16px",
          border: "1px solid #EAECF0",
        }}
      >
        {activeSegment === "Beds Table" ? (
          <>
            {((bedList && bedList?.length) || searchQuery) > 0 ? (
              <UiDataTable
                showHeader={false}
                shellClassName="ui-table-fill-shell"
                onSearch={(e) => onBedSearch(e)}
                searchValue={searchQuery || ""}
                searchPlaceholder="Search bed"
                toolbarTrailing={
                  <Button
                    type="primary"
                    onClick={() => setIsVisible(true)}
                    className={btnStyles.lgBtn}
                  >
                    <PlusOutlined /> Bed
                  </Button>
                }
              >
                <BedTable
                  data={filteredData}
                  refreshBedPage={refreshBedPage}
                  facilityId={id}
                />
              </UiDataTable>
            ) : (
              <Row
                style={{
                  height: "40vh",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Col span={6} style={{ textAlign: "center" }}>
                  <Space direction="vertical">
                    {/* <Typography className={textStyles.body3}>
                      Lorem ipsum dolor sit amet consectetur. Eget et ipsum sed
                      orci dictum.
                    </Typography> */}

                    <Button
                      type="primary"
                      onClick={() => setIsVisible(true)}
                      className={btnStyles.lgBtn}
                    >
                      <PlusOutlined /> Bed
                    </Button>
                  </Space>
                </Col>
              </Row>
            )}
          </>
        ) : (
          <Row>
            <Col span={24}>
              <Buildings facilityId={id} refreshRoom={refresh} />
            </Col>
          </Row>
        )}
      </Card>
      {isVisible && (
        <BedForm
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          facilityId={id}
          refreshBedPage={refreshBedPage}
        />
      )}
      {open && (
        <RoomTypeForm
          open={open}
          setOpen={setOpen}
          editListData={roomTypes}
          refresh={refresh}
          refreshPage={refreshPage}
        />
      )}
    </>
  );
};

export default BedManagement;
